module.exports={
    "两次输入的密码必须一致": "兩次輸入的密碼必須一致",
    "取消": "取消",
    "如验证出现问题，请点击": "如驗證出現問題，請點擊",
    "如验证出现问题，请联系orcalivecs@asiainnovations.com": "如驗證出現問題，請聯繫orcalivecs@asiainnovations.com",
    "如验证出现问题，请联系upcs@asiainnovations.com": "如驗證出現問題，請聯繫upcs@asiainnovations.com",
    "密码修改成功": "密碼修改成功",
    "密码格式错误": "密碼格式錯誤",
    "密码由6-20位由数字和字母组成": "密碼由6-20位由數字和字母組成",
    "恭喜您密码重置成功": "恭喜您密碼重置成功",
    "恭喜您已成功激活帐户": "恭喜您已成功開通帳號",
    "知道了": "知道了",
    "确认修改": "確認修改",
    "网络连接有误, 请稍后再试": "網路連接有誤，請稍後再試",
    "联系客服": "聯繫客服",
    "请再次输入密码": "請再次輸入密碼",
    "请返回UpVoice中重新进行邮箱验证": "請返回UpVoice中重新進行信箱驗證",
    "请返回Up直播中重新进行邮箱验证": "請返回Uplive中重新進行信箱驗證",
    "请返回虎鲸直播中重新进行邮箱验证": "請返回OrcaLive中重新進行信箱驗證",
    "请重新设定登录密码": "請重新設定登入密碼",
    "请重新设置密码": "請重新設置密碼",
    "赶快返回UpVoice中与全球潮人互动吧": "趕快返回UpVoice與全球網路紅人互動吧！",
    "赶快返回Up直播中与全球潮人互动吧！": "趕快返回Uplive與全球網路紅人互動吧！",
    "赶快返回虎鲸直播中与全球潮人互动吧": "趕快返回OrcaLive與全球網路紅人互動吧！",
    "重置密码失败": "重置密碼失敗",
    "验证失败": "驗證失敗",
    "验证成功": "驗證成功"
};


// WEBPACK FOOTER //
// ./js/lang/zhhk.js